import cn from 'classnames';
import * as React from 'react';
import { Success } from '@tcl-boron-icons/icons';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { useLoaderStyles } from './styles';
import { LoaderProps } from './types';
import './keyframes.scss';

const Loader: React.FC<LoaderProps> = ({
  classes: classOverrides = {},
  className = '',
  isComplete = false,
  loaderType = 'primary',
  size = 'large',
  Icon,
  ...props
}) => {
  const classes = mergeClasses(useLoaderStyles({ size, loaderType }), classOverrides, { root: className });

  return (
    <div className={classes.root} data-analytics="loader" {...props} aria-busy={true}>
      {isComplete && <Success className={classes.checkSvg} />}
      {!isComplete && (
        <div className={classes.spinner}>
          <div className={cn(classes.spinnerChildOne, classes.spinnerChildFive)}></div>
          <div className={classes.spinnerChildOne}></div>
          <div className={cn(classes.spinnerChildOne, classes.spinnerChildTwo)}></div>
          <div className={cn(classes.spinnerChildOne, classes.spinnerChildThree)}></div>
          <div className={cn(classes.spinnerChildOne, classes.spinnerChildFour)}></div>
          {Icon && <Icon height="14px" width="14px" className={classes.icon} />}
        </div>
      )}
    </div>
  );
};

export default Loader;
